import PageJivoUtils from '~/mixins/page/page-jivo-utils'

export default {
  mixins: [
    PageJivoUtils
  ],
  beforeMount() {
    this.setCookie()
  },
  methods: {
    setCookie() {
      const domain = window.location.hostname === 'localhost'
        ? `localhost`
        : `.${window.location.hostname}`

      const date = new Date()
      const expiresDate = date.getTime() + 1000 * 60 * 60 * 24 * 365

      /**
       * Устанавливает cookies при переходе по реферальным ссылкам вида /?ref_code=____
       * при условии что cookie ref не существует, либо она была === 'selfselectel'
       */
      if (!document.cookie
          .split('; ')
          .find(item => item.startsWith('ref='))
        || document.cookie
            .split('; ')
            .find(item => item.startsWith('ref='))
            .split('=')[1] === 'selfselectel') {
        document.cookie = this.$route.query.ref_code
          ? `ref=${this.$route.query.ref_code}; domain=${domain}; expires=${expiresDate}; path=/`
          : `ref=selfselectel; domain=${domain}; expires=${expiresDate}; path=/`
      }
    }
  }
}